import React from 'react'

export default ({ element, path, mode }) => {
  const { label, placeholder, hint, id, fieldAnswer } = element
  const inputId = `textarea-input-${id || path.slice(-1)}`

  return (
    <div className="form-group">
      { label && <label htmlFor={inputId} className="label">{label}</label> }
      <div className="default-form-input-wrapper">
        <textarea className="form-control" id={inputId} name="fields_answers_attributes[][value]"
          readOnly={mode.isReadOnly()}
          defaultValue={fieldAnswer}
          placeholder={placeholder}
        />
        <input type="hidden" name="fields_answers_attributes[][field_id]" value={id} />
        { hint && <small>{hint}</small> }
      </div>
    </div>
  )
}
